import { render, staticRenderFns } from "./timeline-note.vue?vue&type=template&id=077941e2&scoped=true"
import script from "./timeline-note.vue?vue&type=script&lang=js"
export * from "./timeline-note.vue?vue&type=script&lang=js"
import style0 from "./timeline-note.vue?vue&type=style&index=0&id=077941e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077941e2",
  null
  
)

export default component.exports